module.exports = __webpack_public_path__ + "static/media/createReminder.373fc94e.png";